import React, { createContext, useReducer, useContext, ReactNode } from 'react'

import { SlotStatus } from '@customTypes/Generic'

type Action = { type: 'setSlotState'; payload: SlotStatus }
type State = {
  slotStatus: SlotStatus
}
type Dispatch = (action: Action) => void
type RescheduleProviderProps = { children: ReactNode }

const RescheduleContext = createContext<State | undefined>(undefined)
const RescheduleDispatchContext = createContext<Dispatch | undefined>(undefined)

const defaultState = {
  slotStatus: SlotStatus.NOT_CHECKED,
}

const rescheduleReducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'setSlotState':
      return { ...state, slotStatus: action.payload }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

export const RescheduleProvider: React.FC<RescheduleProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(rescheduleReducer, defaultState)
  return (
    <RescheduleContext.Provider value={state}>
      <RescheduleDispatchContext.Provider value={dispatch}>{children}</RescheduleDispatchContext.Provider>
    </RescheduleContext.Provider>
  )
}

export const useRescheduleState = () => {
  const context = useContext(RescheduleContext)
  if (context === undefined) {
    throw new Error('useRescheduleState must be user wuthin a RescheduleProvider')
  }
  return context
}

export const useRescheduleDispatch = () => {
  const context = useContext(RescheduleDispatchContext)
  if (context === undefined) {
    throw new Error('useRescheduleDispatch must be used within a RescheduleProvider')
  }
  return context
}

export const setSlotStatus = (payload: SlotStatus): Action => ({ type: 'setSlotState', payload })
